import React, { Fragment, useState } from "react";

import Modal from "../common/Modals/Modal/Modal";
import Typography from "../common/Typography/Typography";
import Card from "../common/Card/Card";
import ButtonNoStyles from "../common/Buttons/ButtonNoStyles/ButtonNoStyles";
import Icon from "../common/Icon/Icon";
import { VIDEO_USER_GUIDE } from "../../config/global.config";

export enum Tours {
    dashboard = "https://player.vimeo.com/video/809198054?h=d49e852288",
    sites = "https://player.vimeo.com/video/809198096?h=dee78bd4c9",
    site = "https://player.vimeo.com/video/809198122?h=82996fd784",
    visit = "https://player.vimeo.com/video/809198141?h=ef052391ee",
    actions = "https://player.vimeo.com/video/809198167?h=38642acdf6",
    reports = "https://player.vimeo.com/video/809198189?h=0db4a36065",
    "health-and-safety" = "https://player.vimeo.com/video/809198206?h=cf238f0fe1",
    contacts = "https://player.vimeo.com/video/809198218?h=8b90245d61",
    "profile-settings" = "https://player.vimeo.com/video/809198238?h=55f5a3f0e3",
    "whats-new" = "",
}

interface Dimensions {
    width: number | "100%";
    height: number;
}

interface ChildProps {
    forwardedRef?: React.Ref<unknown>;
    openModal: () => void;
}

interface Props {
    forwardedRef?: React.Ref<unknown>;
    tour: keyof typeof Tours | "fullvideoguide";
    children: (props: ChildProps) => React.ReactNode;
}

const TakeTheTourModal = ({ tour, children, forwardedRef }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [dimensions, setDimensions] = useState<Dimensions>({ width: "100%", height: 360 });

    const closeModal = () => setIsOpen(false);

    const openModal = () => {
        const ratio = 16 / 9; // Original is 640 by 360;
        const screenWidth = Math.min(640, window.innerWidth - 70); // Get the width, either the max it can be or less, -70 for padding.
        setDimensions({ width: "100%", height: Math.ceil(screenWidth / ratio) });

        setIsOpen((state) => !state);
    };

    const tourToRender = tour === "fullvideoguide" ? VIDEO_USER_GUIDE : Tours[tour];

    return (
        <Fragment>
            {isOpen ? (
                <Modal show={isOpen} onClose={closeModal} full>
                    <Card padding="large" className="space-y-1 rounded-none md:rounded drop-shadow-md max-w-[682px]">
                        <div className="text-right">
                            <ButtonNoStyles onClick={closeModal} title="Close tour">
                                <Icon icon="cross" />
                            </ButtonNoStyles>
                        </div>
                        {tourToRender ? (
                            <iframe
                                title="Vergo tour video"
                                src={tourToRender}
                                width={dimensions.width}
                                height={dimensions.height}
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture"
                                allowFullScreen
                            />
                        ) : (
                            <Typography as="p" variant="paragraph" className="text-center">
                                The tour video could not be found. Please contact support.
                            </Typography>
                        )}
                    </Card>
                </Modal>
            ) : null}
            {children({ openModal, forwardedRef })}
        </Fragment>
    );
};

export default React.forwardRef((props: Props, ref) => <TakeTheTourModal {...props} forwardedRef={ref} />);
